angular.module('app.controllers').controller('VideosListCtrl', ['$scope', '$rootScope', 'UI', 'APIRead', 'APIReadTable', 'Table', 'APIData'].append(function(self, root, UI, APIRead, APIReadTable, Table, APIData) {
  var cookiesName, ref, tableName;
  APIData.query({
    slug: `videos-${root.lang}`
  }, function(data) {
    return self.videos_deep = data;
  }, function(response) {
    return UI.notify(false, response.data.error);
  });
  tableName = 's.videos.' + (((ref = root.user) != null ? ref.shortcode : void 0) || 'test');
  cookiesName = 't.' + tableName;
  APIRead.query({
    limit: 3,
    entry_type: 'videos',
    reverse: false,
    lang: root.lang
  }, function(data) {
    return self.topvideos = data;
  }, function(response) {
    return UI.notify(false, response.data.error);
  });
  self.videos = Table({
    name: tableName,
    type: "partial",
    resource: APIReadTable,
    params: {
      limit: 12,
      entry_type: 'videos',
      offset_increase: 3,
      lang: root.lang
    }
  });
  self.$watch('videos.params', function(newObj, oldObj) {
    return self.page = 1;
  }, true);
  self.page = 1;
  return self.loadMore = function() {
    var params;
    if (self.page >= self.videos.data.pages) {
      return;
    }
    self.page++;
    params = angular.copy(self.videos.params);
    params.page = self.page;
    self.moreLoad = true;
    return APIRead.query(params, function(data) {
      self.more = data;
      self.videos.data.display = self.videos.data.display.concat(self.more);
      return self.moreLoad = false;
    }, function(response) {
      return UI.notify(false, response.data.error);
    });
  };
}));
